export const WORKOS_CLIENT_ID = import.meta.env.VITE_WORKOS_CLIENT_ID;
export const WORKOS_DEV_MODE = import.meta.env.VITE_WORKOS_DEV_MODE === 'true';

// Envalid rejects a malformed VITE_WORKOS_API_URL at dev/build startup, so a
// parse failure here is unexpected — fall back to real WorkOS rather than crash.
function parseWorkOSApiUrl(): URL | null {
  const value = import.meta.env.VITE_WORKOS_API_URL;
  if (!value) return null;
  try {
    return new URL(value);
  } catch {
    return null;
  }
}

export const WORKOS_API_URL = parseWorkOSApiUrl();

export const sentryConfig = {
  dsn: import.meta.env.VITE_SENTRY_DSN_URL || '',
  release: import.meta.env.VITE_RELEASE_SHA,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.VITE_DEV_ENABLE_SENTRY || !import.meta.env.DEV,
  sendDefaultPii: true,
  tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || 1.0),
  tracePropagationTargets: ['localhost', /^\//, /^https:\/\/.+\.enrichnetwork\.io\/v1/],
  enableLogs: true,
};

export const SERVER_URL = !import.meta.env.VITE_SERVER_URL
  ? `//${window.location.host}`
  : import.meta.env.VITE_SERVER_URL;

export const API_URL = `${SERVER_URL}/v1`;

export enum ReceiptStatus {
  inReview = 'in_review',
  processingComplete = 'processing_complete',
  enriched = 'enriched',
}
export enum ReviewStatus {
  processing = 'processing',
}

export enum LoyaltyActions {
  user_sign_up = 'Sign up as a user',
  user_referral = 'Refer a user',

  receipt_upload = 'Upload a receipt',
  receipt_submit_for_review = 'Submit a receipt for review',

  connect_account = 'Connect a financial account',
  monthly_active_accounts = 'Monthly active financial accounts',

  feature_rating = 'Rate a feature',
  survey_response = 'Respond to a survey',
  user_study = 'Participate in user study',
}
if (import.meta.env.MODE === 'development') {
  console.debug('WORKOS_CLIENT_ID', WORKOS_CLIENT_ID);
  console.debug('SERVER_URL', SERVER_URL);
  console.debug('API_URL', API_URL);
}

export const MERCHANT_NAME_LOGO_MAP = {
  'whole foods market': 'whole_foods.svg',
  safeway: 'safeway.svg',
  target: 'target.svg',
  walmart: 'walmart.svg',
  publix: 'publix.png',
  walgreens: 'walgreens.svg',
  cvs: 'cvs.svg',
  amazon: 'amazon.svg',
};

export enum TransactionCategoryType {
  INCOME = 'Inflow',
  EXPENSE = 'Outflow',
}

export const ENRICH_REWARDS_NICKNAME = 'Enrich Rewards';
export const ENRICH_BALANCE_NICKNAME = 'Enrich Balance';
export const REFER_A_FRIEND_PROGRAM_TITLE = 'Refer A Friend';
export const ENRICH_BALANCE_ACCOUNT_TYPE = 'enrich_balance';
export const ENRICH_REWARDS_ACCOUNT_TYPE = 'enrich_rewards';
export const LOYALTY_PROGRAM_ACCOUNT_TYPE = 'loyalty_program';
export const BENEFIT_PROGRAM_ACCOUNT_TYPE = 'benefit_program';
/** Conversion rate from an Enrich Rewards USD ledger balance to display points (mirrors backend loyaltyprograms.PointsPerDollar). */
export const POINTS_PER_DOLLAR = 1000;

/**
 * Giftogram's minimum digital gift-card order, in whole dollars. Mirrors the
 * backend `minGiftCardRedemptionDollars` in gift_card_handler.go.
 */
export const MIN_GIFT_CARD_REDEMPTION_DOLLARS = 5;

export const MAX_USERS_PER_TAG_BATCH = 5000;

export const TERMS_OF_SERVICE_URL = 'https://enrichnetwork.io/terms';

export const RESOURCES_HUB_URL = 'https://enrichnetwork.io/resources';

export const REFERRAL_LEARN_MORE_URL = 'https://enrichnetwork.notion.site/how-to-refer-a-friend';

export const PERSONA_LEARN_MORE_URL = 'https://withpersona.com';

export const SUPPORT_EMAIL = 'support@enrichnetwork.io';

export const REFERRAL_POINTS_PER_REFERRAL = 2000;
export const REFERRAL_SIGN_UP_POINTS = 2000;
export const REFERRAL_RECEIPTS_REQUIRED = 5;

/** Nicknames that are reserved and cannot be used for any account */
export const RESERVED_ACCOUNT_NICKNAMES = [ENRICH_BALANCE_NICKNAME, ENRICH_REWARDS_NICKNAME];

export const TALLY_FORMS = {
  SHARE_FEEDBACK_FORM_ID: 'nPaYVb',
  MONEY_CIRCLE_RATE_FORM_ID: '2EKAlg',
};
